'use client';

import { useEffect, useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAuth } from '@/contexts/auth-context';
import { fetchMyCompanies, MyCompany } from '@/lib/me-companies';

interface CompanySwitcherProps {
  className?: string;
}

// 로그인 후 활성 회사(테넌트)를 전환하는 스위처.
// 슈퍼어드민 전용 CompanySelector(클라 필터 목적)와는 별개로,
// 다중 회사 소속 사용자의 활성 조직 자체를 바꾼다(재로그인 수반).
export function CompanySwitcher({ className }: CompanySwitcherProps) {
  const { getCompanyCode, switchCompany } = useAuth();
  const [companies, setCompanies] = useState<MyCompany[]>([]);

  useEffect(() => {
    let cancelled = false;
    fetchMyCompanies()
      .then(result => {
        if (!cancelled) setCompanies(result);
      })
      .catch(() => {
        // 부가 UI이므로 실패해도 조용히 무시(스위처 미노출)
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // 단일 회사 소속이면 전환 불필요 → 렌더하지 않음
  if (companies.length <= 1) {
    return null;
  }

  const currentCompCd = getCompanyCode();

  const handleChange = (compCd: string) => {
    if (compCd.toLowerCase() === currentCompCd?.toLowerCase()) return;
    switchCompany(compCd);
  };

  return (
    <div className={className}>
      <label className='text-xs text-muted-foreground mb-1 block'>
        소속 회사
      </label>
      <Select
        value={currentCompCd ?? undefined}
        onValueChange={handleChange}
      >
        <SelectTrigger className='h-8 text-xs'>
          <SelectValue placeholder='회사 선택' />
        </SelectTrigger>
        <SelectContent>
          {companies.map(company => (
            <SelectItem
              key={company.compCd}
              value={company.compCd}
              className='text-xs'
            >
              {company.compName ?? company.compCd}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
